import React from "react";

export const documentIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4.21875 1.125C3.4421 1.125 2.8125 1.7546 2.8125 2.53125V15.4688C2.8125 16.2454 3.4421 16.875 4.21875 16.875H13.7812C14.5579 16.875 15.1875 16.2454 15.1875 15.4688V9.5625C15.1875 8.0092 13.9283 6.75 12.375 6.75H10.9688C10.1921 6.75 9.5625 6.1204 9.5625 5.34375V3.9375C9.5625 2.3842 8.3033 1.125 6.75 1.125H4.21875ZM5.625 11.25C5.625 10.9393 5.87684 10.6875 6.1875 10.6875H11.8125C12.1232 10.6875 12.375 10.9393 12.375 11.25C12.375 11.5607 12.1232 11.8125 11.8125 11.8125H6.1875C5.87684 11.8125 5.625 11.5607 5.625 11.25ZM6.1875 12.9375C5.87684 12.9375 5.625 13.1893 5.625 13.5C5.625 13.8107 5.87684 14.0625 6.1875 14.0625H9C9.31066 14.0625 9.5625 13.8107 9.5625 13.5C9.5625 13.1893 9.31066 12.9375 9 12.9375H6.1875Z"
      fill="#D9D9D9"
    />
    <path
      d="M9.72839 1.36193C10.326 2.05236 10.6875 2.95271 10.6875 3.9375V5.34375C10.6875 5.49908 10.8134 5.625 10.9688 5.625H12.375C13.3598 5.625 14.2601 5.98653 14.9506 6.58411C14.2847 4.03491 12.2776 2.02783 9.72839 1.36193Z"
      fill="#D9D9D9"
    />
  </svg>
);

export const documentTextIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="21"
    height="20"
    viewBox="0 0 21 20"
    fill="none"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.10852 1.25C4.24558 1.25 3.54602 1.94955 3.54602 2.8125V17.1875C3.54602 18.0504 4.24558 18.75 5.10852 18.75H15.7335C16.5965 18.75 17.296 18.0504 17.296 17.1875V10.625C17.296 8.89911 15.8969 7.5 14.171 7.5H12.6085C11.7456 7.5 11.046 6.80044 11.046 5.9375V4.375C11.046 2.64911 9.64691 1.25 7.92102 1.25H5.10852ZM6.67102 12.5C6.67102 12.1548 6.95084 11.875 7.29602 11.875H13.546C13.8912 11.875 14.171 12.1548 14.171 12.5C14.171 12.8452 13.8912 13.125 13.546 13.125H7.29602C6.95084 13.125 6.67102 12.8452 6.67102 12.5ZM7.29602 14.375C6.95084 14.375 6.67102 14.6548 6.67102 15C6.67102 15.3452 6.95084 15.625 7.29602 15.625H10.421C10.7662 15.625 11.046 15.3452 11.046 15C11.046 14.6548 10.7662 14.375 10.421 14.375H7.29602Z"
      fill="#747474"
    />
    <path
      d="M11.2303 1.51325C11.8943 2.2804 12.296 3.28079 12.296 4.375V5.9375C12.296 6.11009 12.4359 6.25 12.6085 6.25H14.171C15.2652 6.25 16.2656 6.6517 17.0328 7.31567C16.2929 4.48323 14.0628 2.25315 11.2303 1.51325Z"
      fill="#747474"
    />
  </svg>
);

export const imageIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M1.125 4.5C1.125 3.56802 1.88052 2.8125 2.8125 2.8125H15.1875C16.1195 2.8125 16.875 3.56802 16.875 4.5V13.5C16.875 14.432 16.1195 15.1875 15.1875 15.1875H2.8125C1.88052 15.1875 1.125 14.432 1.125 13.5V4.5ZM2.25 12.0455V13.5C2.25 13.8107 2.50184 14.0625 2.8125 14.0625H15.1875C15.4982 14.0625 15.75 13.8107 15.75 13.5V12.0455L13.733 10.0285C13.2937 9.58915 12.5813 9.58915 12.142 10.0285L11.483 10.6875L12.2102 11.4148C12.4299 11.6344 12.4299 11.9906 12.2102 12.2102C11.9906 12.4299 11.6344 12.4299 11.4148 12.2102L7.5455 8.34099C7.10615 7.90165 6.39385 7.90165 5.95451 8.34099L2.25 12.0455ZM9.84375 6.1875C9.84375 5.72151 10.2215 5.34375 10.6875 5.34375C11.1535 5.34375 11.5312 5.72151 11.5312 6.1875C11.5312 6.65349 11.1535 7.03125 10.6875 7.03125C10.2215 7.03125 9.84375 6.65349 9.84375 6.1875Z"
      fill="#D9D9D9"
    />
  </svg>
);

export const videoIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M1.125 4.21875C1.125 3.4421 1.7546 2.8125 2.53125 2.8125H15.4688C16.2454 2.8125 16.875 3.4421 16.875 4.21875V13.7812C16.875 14.5579 16.2454 15.1875 15.4688 15.1875H2.53125C1.7546 15.1875 1.125 14.5579 1.125 13.7812V4.21875ZM2.25 4.21875V5.34375C2.25 5.49908 2.37592 5.625 2.53125 5.625H3.65625C3.81158 5.625 3.9375 5.49908 3.9375 5.34375V4.21875C3.9375 4.06342 3.81158 3.9375 3.65625 3.9375H2.53125C2.37592 3.9375 2.25 4.06342 2.25 4.21875ZM14.3438 3.9375C14.1884 3.9375 14.0625 4.06342 14.0625 4.21875V5.34375C14.0625 5.49908 14.1884 5.625 14.3438 5.625H15.4688C15.6241 5.625 15.75 5.49908 15.75 5.34375V4.21875C15.75 4.06342 15.6241 3.9375 15.4688 3.9375H14.3438ZM15.75 7.03125C15.75 6.87592 15.6241 6.75 15.4688 6.75H14.3438C14.1884 6.75 14.0625 6.87592 14.0625 7.03125V8.15625C14.0625 8.31158 14.1884 8.4375 14.3438 8.4375H15.4688C15.6241 8.4375 15.75 8.31158 15.75 8.15625V7.03125ZM15.75 9.84375C15.75 9.68842 15.6241 9.5625 15.4688 9.5625H14.3438C14.1884 9.5625 14.0625 9.68842 14.0625 9.84375V10.9688C14.0625 11.1241 14.1884 11.25 14.3438 11.25H15.4688C15.6241 11.25 15.75 11.1241 15.75 10.9688V9.84375ZM15.75 12.6562C15.75 12.5009 15.6241 12.375 15.4688 12.375H14.3438C14.1884 12.375 14.0625 12.5009 14.0625 12.6562V13.7812C14.0625 13.9366 14.1884 14.0625 14.3438 14.0625H15.4688C15.6241 14.0625 15.75 13.9366 15.75 13.7812V12.6562ZM3.65625 14.0625C3.81158 14.0625 3.9375 13.9366 3.9375 13.7812V12.6562C3.9375 12.5009 3.81158 12.375 3.65625 12.375H2.53125C2.37592 12.375 2.25 12.5009 2.25 12.6562V13.7812C2.25 13.9366 2.37592 14.0625 2.53125 14.0625H3.65625ZM2.53125 11.25H3.65625C3.81158 11.25 3.9375 11.1241 3.9375 10.9688V9.84375C3.9375 9.68842 3.81158 9.5625 3.65625 9.5625H2.53125C2.37592 9.5625 2.25 9.68842 2.25 9.84375V10.9688C2.25 11.1241 2.37592 11.25 2.53125 11.25ZM2.53125 8.4375H3.65625C3.81158 8.4375 3.9375 8.31158 3.9375 8.15625V7.03125C3.9375 6.87592 3.81158 6.75 3.65625 6.75H2.53125C2.37592 6.75 2.25 6.87592 2.25 7.03125V8.15625C2.25 8.31158 2.37592 8.4375 2.53125 8.4375ZM5.625 8.4375C5.31434 8.4375 5.0625 8.68934 5.0625 9C5.0625 9.31066 5.31434 9.5625 5.625 9.5625H12.375C12.6857 9.5625 12.9375 9.31066 12.9375 9C12.9375 8.68934 12.6857 8.4375 12.375 8.4375H5.625Z"
      fill="#D9D9D9"
    />
  </svg>
);

export const chatBubbleIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
  >
    <path
      d="M4.09423 2.21519C5.82308 1.99073 7.5858 1.875 9.37524 1.875C11.1645 1.875 12.927 1.99071 14.6557 2.21513C16.2576 2.42308 17.3986 3.76614 17.4936 5.32079C17.2221 5.23012 16.9343 5.16997 16.6334 5.14499C15.4762 5.04895 14.3061 5 13.125 5C11.9439 5 10.7738 5.04895 9.61665 5.14498C7.65142 5.30809 6.25 6.97056 6.25 8.84018V12.4114C6.25 13.8203 7.04557 15.1105 8.27734 15.7315L6.06694 17.9419C5.88819 18.1207 5.61937 18.1742 5.38582 18.0774C5.15228 17.9807 5 17.7528 5 17.5V14.1421C4.69708 14.1097 4.39514 14.0739 4.09424 14.0348C2.42055 13.8175 1.25 12.3611 1.25 10.7189V5.53115C1.25 3.88893 2.42055 2.43249 4.09423 2.21519Z"
      fill="#747474"
    />
    <path
      d="M13.125 6.25C11.9784 6.25 10.8428 6.29751 9.72004 6.3907C8.4373 6.49717 7.5 7.58568 7.5 8.84018V12.4114C7.5 13.6678 8.43997 14.7569 9.72434 14.8618C10.7609 14.9464 11.8084 14.9927 12.8653 14.9992L15.1831 17.3169C15.3618 17.4957 15.6306 17.5492 15.8642 17.4524C16.0977 17.3557 16.25 17.1278 16.25 16.875V14.8834C16.342 14.8765 16.4338 14.8693 16.5256 14.8619C17.81 14.757 18.75 13.6679 18.75 12.4115V8.84018C18.75 7.58569 17.8127 6.49717 16.53 6.39071C15.4072 6.29752 14.2716 6.25 13.125 6.25Z"
      fill="#747474"
    />
  </svg>
);

export const chatIconOutlined = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
  >
    <path
      d="M16.875 7.09253C17.6117 7.32957 18.125 8.03267 18.125 8.84018V12.4115C18.125 13.3587 17.4188 14.1619 16.4748 14.2389C16.1923 14.262 15.9091 14.2821 15.625 14.2994V16.875L13.125 14.375C11.9969 14.375 10.8797 14.329 9.77519 14.2388C9.5266 14.2186 9.2945 14.1479 9.08745 14.0375M16.875 7.09253C16.7488 7.05193 16.6161 7.025 16.4783 7.01356C15.3727 6.9218 14.2543 6.875 13.125 6.875C11.9957 6.875 10.8773 6.9218 9.77174 7.01356C8.82916 7.09179 8.125 7.89436 8.125 8.84018V12.4114C8.125 13.1092 8.50822 13.7288 9.08745 14.0375M16.875 7.09253V5.53109C16.875 4.17991 15.9152 3.00887 14.5753 2.83492C12.8732 2.61396 11.1375 2.5 9.37524 2.5C7.61278 2.5 5.87694 2.61399 4.1747 2.83499C2.83477 3.00895 1.875 4.17998 1.875 5.53115V10.7189C1.875 12.07 2.83478 13.2411 4.1747 13.415C4.65551 13.4774 5.13899 13.5313 5.625 13.5765V17.5L9.08745 14.0375"
      stroke="#747474"
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const chatIconSolid = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
  >
    <path
      d="M4.09423 2.21519C5.82308 1.99073 7.5858 1.875 9.37524 1.875C11.1645 1.875 12.927 1.99071 14.6557 2.21513C16.2576 2.42308 17.3986 3.76614 17.4936 5.32079C17.2221 5.23012 16.9343 5.16997 16.6334 5.14499C15.4762 5.04895 14.3061 5 13.125 5C11.9439 5 10.7738 5.04895 9.61665 5.14498C7.65142 5.30809 6.25 6.97056 6.25 8.84018V12.4114C6.25 13.8203 7.04557 15.1105 8.27734 15.7315L6.06694 17.9419C5.88819 18.1207 5.61937 18.1742 5.38582 18.0774C5.15228 17.9807 5 17.7528 5 17.5V14.1421C4.69708 14.1097 4.39514 14.0739 4.09424 14.0348C2.42055 13.8175 1.25 12.3611 1.25 10.7189V5.53115C1.25 3.88893 2.42055 2.43249 4.09423 2.21519Z"
      fill="#747474"
    />
    <path
      d="M13.125 6.25C11.9784 6.25 10.8428 6.29751 9.72004 6.3907C8.4373 6.49717 7.5 7.58568 7.5 8.84018V12.4114C7.5 13.6678 8.43997 14.7569 9.72434 14.8618C10.7609 14.9464 11.8084 14.9927 12.8653 14.9992L15.1831 17.3169C15.3618 17.4957 15.6306 17.5492 15.8642 17.4524C16.0977 17.3557 16.25 17.1278 16.25 16.875V14.8834C16.342 14.8765 16.4338 14.8693 16.5256 14.8619C17.81 14.757 18.75 13.6679 18.75 12.4115V8.84018C18.75 7.58569 17.8127 6.49717 16.53 6.39071C15.4072 6.29752 14.2716 6.25 13.125 6.25Z"
      fill="#747474"
    />
  </svg>
);

export const chatIconSolidBlue = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="28"
    height="28"
    viewBox="0 0 28 28"
    fill="none"
  >
    <path
      d="M5.73192 3.10127C8.15232 2.78703 10.6201 2.625 13.1253 2.625C15.6303 2.625 18.0979 2.78699 20.518 3.10118C22.7607 3.39231 24.3581 5.2726 24.491 7.4491C24.1109 7.32216 23.7081 7.23796 23.2867 7.20299C21.6667 7.06853 20.0285 7 18.375 7C16.7214 7 15.0833 7.06852 13.4633 7.20298C10.712 7.43133 8.75 9.75878 8.75 12.3762V17.376C8.75 19.3484 9.86379 21.1547 11.5883 22.0242L8.49372 25.1187C8.24347 25.369 7.86712 25.4438 7.54015 25.3084C7.21319 25.173 7 24.8539 7 24.5V19.799C6.57591 19.7535 6.1532 19.7034 5.73193 19.6488C3.38877 19.3445 1.75 17.3055 1.75 15.0064V7.74361C1.75 5.44451 3.38877 3.40548 5.73192 3.10127Z"
      fill="#78C1CE"
    />
    <path
      d="M18.375 8.75C16.7698 8.75 15.1799 8.81652 13.6081 8.94698C11.8122 9.09603 10.5 10.62 10.5 12.3762V17.376C10.5 19.1349 11.816 20.6597 13.6141 20.8065C15.0652 20.9249 16.5317 20.9897 18.0114 20.9989L21.2563 24.2437C21.5065 24.494 21.8829 24.5688 22.2098 24.4334C22.5368 24.298 22.75 23.9789 22.75 23.625V20.8368C22.8787 20.8271 23.0074 20.8171 23.1358 20.8066C24.934 20.6599 26.25 19.1351 26.25 17.3761V12.3763C26.25 10.62 24.9378 9.09604 23.1419 8.94699C21.57 8.81652 19.9802 8.75 18.375 8.75Z"
      fill="#78C1CE"
    />
  </svg>
);
export const attachFileIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="9"
    height="18"
    viewBox="0 0 9 18"
    fill="none"
  >
    <path
      d="M7.77273 4.09091L7.77273 13.5C7.77273 15.3082 6.30818 16.7727 4.5 16.7727C2.69182 16.7727 1.22727 15.3082 1.22727 13.5L1.22727 3.27273C1.22727 2.14364 2.14364 1.22727 3.27273 1.22727C4.40182 1.22727 5.31818 2.14364 5.31818 3.27273L5.31818 11.8636C5.31818 12.3136 4.95 12.6818 4.5 12.6818C4.05 12.6818 3.68182 12.3136 3.68182 11.8636L3.68182 4.09091L2.45455 4.09091L2.45455 11.8636C2.45455 12.9927 3.37091 13.9091 4.5 13.9091C5.62909 13.9091 6.54545 12.9927 6.54545 11.8636L6.54545 3.27273C6.54545 1.46455 5.08091 0 3.27273 0C1.46455 0 0 1.46455 0 3.27273L0 13.5C0 15.9873 2.01273 18 4.5 18C6.98727 18 9 15.9873 9 13.5L9 4.09091L7.77273 4.09091Z"
      fill="white"
    />
  </svg>
);

export const PinIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="12"
    height="12"
    viewBox="0 0 12 12"
    fill="none"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.16729 8.7825C8.33346 8.61633 8.3476 8.36177 8.23093 8.15317C7.90566 7.58042 7.98698 6.84149 8.47488 6.35358L10.2426 4.58582L10.5962 4.93937C10.7907 5.13383 11.1089 5.13383 11.3033 4.93937C11.4978 4.74492 11.4978 4.42672 11.3033 4.23226L7.76778 0.696731C7.57332 0.502276 7.25512 0.502276 7.06067 0.696731C6.86621 0.891185 6.86621 1.20938 7.06067 1.40384L7.41422 1.75739L5.64646 3.52516C5.15855 4.01306 4.41963 4.09438 3.84687 3.76911C3.63827 3.65244 3.38371 3.66658 3.21754 3.83275L3.17158 3.87871C2.97713 4.07317 2.97713 4.39136 3.17158 4.58582L4.93228 6.34651L2.46447 8.82846C2.27002 9.02291 2.27002 9.34111 2.46447 9.53557C2.65893 9.73002 2.97713 9.73002 3.17158 9.53557L5.63938 7.05362L7.41422 8.82846C7.60868 9.02291 7.92687 9.02291 8.12133 8.82846L8.16729 8.7825Z"
      fill="#747474"
    />
  </svg>
);

export const checkCircle = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
  >
    <g clipPath="url(#clip0_11_4846)">
      <path
        d="M9.99984 1.66675C5.39984 1.66675 1.6665 5.40008 1.6665 10.0001C1.6665 14.6001 5.39984 18.3334 9.99984 18.3334C14.5998 18.3334 18.3332 14.6001 18.3332 10.0001C18.3332 5.40008 14.5998 1.66675 9.99984 1.66675ZM7.7415 13.5751L4.74984 10.5834C4.42484 10.2584 4.42484 9.73341 4.74984 9.40841C5.07484 9.08341 5.59984 9.08341 5.92484 9.40841L8.33317 11.8084L14.0665 6.07508C14.3915 5.75008 14.9165 5.75008 15.2415 6.07508C15.5665 6.40008 15.5665 6.92508 15.2415 7.25008L8.9165 13.5751C8.59984 13.9001 8.0665 13.9001 7.7415 13.5751Z"
        fill="#9CBB65"
      />
    </g>
    <defs>
      <clipPath id="clip0_11_4846">
        <rect width="20" height="20" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const deleteIconSimple = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="18"
    viewBox="0 0 16 18"
    fill="none"
    style={{ stroke: "#747474", strokeWidth: "1.2px" }}
  >
    <path
      d="M10.3252 6.45457L10.0315 14.0909M5.96853 14.0909L5.67483 6.45457M14.1326 3.73141C14.4227 3.77523 14.7119 3.82212 15 3.87203M14.1326 3.73141L13.2265 15.5101C13.15 16.5047 12.3206 17.2727 11.323 17.2727H4.67697C3.6794 17.2727 2.85001 16.5047 2.7735 15.5101L1.86745 3.73141M14.1326 3.73141C13.1598 3.58451 12.1758 3.47202 11.1818 3.39521M1 3.87203C1.28812 3.82212 1.57728 3.77523 1.86745 3.73141M1.86745 3.73141C2.84017 3.58451 3.82418 3.47202 4.81818 3.39521M11.1818 3.39521V2.61788C11.1818 1.61721 10.4091 0.781794 9.40898 0.7498C8.94116 0.734835 8.47146 0.727295 8 0.727295C7.52854 0.727295 7.05884 0.734835 6.59102 0.7498C5.59086 0.781794 4.81818 1.61721 4.81818 2.61788V3.39521M11.1818 3.39521C10.1319 3.31407 9.07076 3.27275 8 3.27275C6.92924 3.27275 5.86813 3.31407 4.81818 3.39521"
      stroke="#747474"
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const downloadIconSimple = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="17"
    height="17"
    viewBox="0 0 17 17"
    fill="none"
  >
    <path
      d="M8.02344 6.86328V11.3633M8.02344 11.3633L6.02344 9.36328M8.02344 11.3633L10.0234 9.36328M4.52344 13.3633C2.86658 13.3633 1.52344 12.0201 1.52344 10.3633C1.52344 9.03465 2.38714 7.90775 3.5837 7.51341C3.54413 7.30275 3.52344 7.08543 3.52344 6.86328C3.52344 4.93028 5.09044 3.36328 7.02344 3.36328C8.64426 3.36328 10.0078 4.46502 10.4059 5.96045C10.6004 5.89737 10.8079 5.86328 11.0234 5.86328C12.128 5.86328 13.0234 6.75871 13.0234 7.86328C13.0234 8.09537 12.9839 8.31823 12.9112 8.52549C13.8537 8.88358 14.5234 9.79521 14.5234 10.8633C14.5234 12.244 13.4041 13.3633 12.0234 13.3633H4.52344Z"
      stroke="#FFFFFF"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const expandIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
  >
    <path
      d="M10 18.3333L5 13.3333L6.1875 12.1458L10 15.9583L13.8125 12.1458L15 13.3333L10 18.3333ZM6.20833 7.83332L5 6.66666L10 1.66666L15 6.66666L13.7917 7.83332L10 4.04166L6.20833 7.83332Z"
      fill="#747474"
    />
  </svg>
);

export const icon360 = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
  >
    <g clipPath="url(#clip0_468_5287)">
      <path
        d="M8.00016 4.66666C4.32016 4.66666 1.3335 6.15999 1.3335 7.99999C1.3335 9.49332 3.2935 10.7533 6.00016 11.18V12.5267C6.00016 12.8267 6.36016 12.9733 6.56683 12.76L8.42683 10.9C8.56016 10.7667 8.56016 10.56 8.42683 10.4267L6.56683 8.56666C6.36016 8.35999 6.00016 8.50666 6.00016 8.80666V9.81999C3.90016 9.44666 2.66683 8.55332 2.66683 7.99999C2.66683 7.29332 4.6935 5.99999 8.00016 5.99999C11.3068 5.99999 13.3335 7.29332 13.3335 7.99999C13.3335 8.43999 12.5335 9.11999 11.1202 9.55999C10.8468 9.64666 10.6668 9.89999 10.6668 10.1867C10.6668 10.6333 11.1002 10.96 11.5202 10.8267C13.4068 10.24 14.6668 9.19332 14.6668 7.99999C14.6668 6.15999 11.6802 4.66666 8.00016 4.66666Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_468_5287">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const infoIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="14"
    height="14"
    viewBox="0 0 16 16"
    fill="none"
  >
    <g clipPath="url(#clip0_165_4470)">
      <path
        d="M7.99992 1.3335C4.31992 1.3335 1.33325 4.32016 1.33325 8.00016C1.33325 11.6802 4.31992 14.6668 7.99992 14.6668C11.6799 14.6668 14.6666 11.6802 14.6666 8.00016C14.6666 4.32016 11.6799 1.3335 7.99992 1.3335ZM7.99992 11.3335C7.63325 11.3335 7.33325 11.0335 7.33325 10.6668V8.00016C7.33325 7.6335 7.63325 7.3335 7.99992 7.3335C8.36658 7.3335 8.66658 7.6335 8.66658 8.00016V10.6668C8.66658 11.0335 8.36658 11.3335 7.99992 11.3335ZM8.66658 6.00016H7.33325V4.66683H8.66658V6.00016Z"
        fill="#4D4D4D"
      />
    </g>
    <defs>
      <clipPath id="clip0_165_4470">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const linkIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
  >
    <path
      d="M12.2322 4.23223C13.2085 3.25592 14.7915 3.25592 15.7678 4.23223C16.7441 5.20854 16.7441 6.79146 15.7678 7.76777L14.5434 8.9921C14.2505 9.28499 14.2505 9.75987 14.5434 10.0528C14.8363 10.3457 15.3112 10.3457 15.6041 10.0528L16.8284 8.82843C18.3905 7.26633 18.3905 4.73367 16.8284 3.17157C15.2663 1.60948 12.7337 1.60948 11.1716 3.17157L8.17157 6.17157C6.60948 7.73367 6.60948 10.2663 8.17157 11.8284C8.24449 11.9013 8.31963 11.9709 8.3968 12.0372C8.71107 12.307 9.18457 12.271 9.45441 11.9567C9.72424 11.6425 9.68822 11.169 9.37395 10.8991C9.32556 10.8576 9.27828 10.8138 9.23223 10.7678C8.25592 9.79145 8.25592 8.20854 9.23223 7.23223L12.2322 4.23223Z"
      fill="#4F98BC"
    />
    <path
      d="M11.6032 7.96278C11.2889 7.69295 10.8154 7.72897 10.5456 8.04324C10.2758 8.3575 10.3118 8.83101 10.626 9.10084C10.6744 9.14239 10.7217 9.18618 10.7678 9.23222C11.7441 10.2085 11.7441 11.7914 10.7678 12.7678L7.76777 15.7678C6.79146 16.7441 5.20854 16.7441 4.23223 15.7678C3.25592 14.7914 3.25592 13.2085 4.23223 12.2322L5.45657 11.0079C5.74946 10.715 5.74946 10.2401 5.45657 9.94723C5.16367 9.65433 4.6888 9.65433 4.39591 9.94723L3.17157 11.1716C1.60948 12.7337 1.60948 15.2663 3.17157 16.8284C4.73367 18.3905 7.26633 18.3905 8.82843 16.8284L11.8284 13.8284C13.3905 12.2663 13.3905 9.73366 11.8284 8.17156C11.7555 8.09864 11.6804 8.02904 11.6032 7.96278Z"
      fill="#4F98BC"
    />
  </svg>
);

export const minimizeIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
  >
    <g clipPath="url(#clip0_493_7990)">
      <path d="M5 9.16667H15V10.8333H5V9.16667Z" fill="#747474" />
    </g>
    <defs>
      <clipPath id="clip0_493_7990">
        <rect width="20" height="20" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const radioButtonUnchecked = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
  >
    <g clipPath="url(#clip0_11_4560)">
      <path
        d="M9.99984 1.66675C5.39984 1.66675 1.6665 5.40008 1.6665 10.0001C1.6665 14.6001 5.39984 18.3334 9.99984 18.3334C14.5998 18.3334 18.3332 14.6001 18.3332 10.0001C18.3332 5.40008 14.5998 1.66675 9.99984 1.66675ZM9.99984 16.6667C6.3165 16.6667 3.33317 13.6834 3.33317 10.0001C3.33317 6.31675 6.3165 3.33341 9.99984 3.33341C13.6832 3.33341 16.6665 6.31675 16.6665 10.0001C16.6665 13.6834 13.6832 16.6667 9.99984 16.6667Z"
        fill="#D9D9D9"
      />
    </g>
    <defs>
      <clipPath id="clip0_11_4560">
        <rect width="20" height="20" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const replayCircledFilled = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
  >
    <g clipPath="url(#clip0_165_4748)">
      <path
        d="M9.99984 1.6665C5.39984 1.6665 1.6665 5.39984 1.6665 9.99984C1.6665 14.5998 5.39984 18.3332 9.99984 18.3332C14.5998 18.3332 18.3332 14.5998 18.3332 9.99984C18.3332 5.39984 14.5998 1.6665 9.99984 1.6665ZM14.9998 10.6165C14.8998 13.1915 12.7748 15.3165 10.1998 15.4165C7.6915 15.5165 5.5665 13.7582 5.09984 11.3998C4.9915 10.8915 5.39984 10.4165 5.9165 10.4165C6.30817 10.4165 6.64984 10.6915 6.73317 11.0832C7.08317 12.8082 8.7665 14.0582 10.6665 13.6832C11.9665 13.4332 13.0165 12.3832 13.2665 11.0832C13.6832 8.94984 12.0582 7.08317 9.99984 7.08317V8.57484C9.99984 8.94984 9.54984 9.13317 9.2915 8.8665L6.95817 6.5415C6.7915 6.37484 6.7915 6.1165 6.95817 5.94984L9.28317 3.62484C9.54984 3.3665 9.99984 3.54984 9.99984 3.92484V5.4165C12.8248 5.4165 15.1082 7.7665 14.9998 10.6165Z"
        fill="#9A1010"
      />
    </g>
    <defs>
      <clipPath id="clip0_165_4748">
        <rect width="20" height="20" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const shapeIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="18"
    height="20"
    viewBox="0 0 18 20"
    fill="none"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M1.5 18.5L0 20V0L1.5 1.5L3 0L4.5 1.5L6 0L7.5 1.5L9 0L10.5 1.5L12 0L13.5 1.5L15 0L16.5 1.5L18 0V20L16.5 18.5L15 20L13.5 18.5L12 20L10.5 18.5L9 20L7.5 18.5L6 20L4.5 18.5L3 20L1.5 18.5ZM15 5V7H3V5H15ZM3 9V11H15V9H3ZM3 13V15H15V13H3Z"
      fill="#4D4D4D"
    />
  </svg>
);

export const filmIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="currentColor"
    class="size-6"
  >
    <path
      fillRule="evenodd"
      d="M1.5 5.625c0-1.036.84-1.875 1.875-1.875h17.25c1.035 0 1.875.84 1.875 1.875v12.75c0 1.035-.84 1.875-1.875 1.875H3.375A1.875 1.875 0 0 1 1.5 18.375V5.625Zm1.5 0v1.5c0 .207.168.375.375.375h1.5a.375.375 0 0 0 .375-.375v-1.5a.375.375 0 0 0-.375-.375h-1.5A.375.375 0 0 0 3 5.625Zm16.125-.375a.375.375 0 0 0-.375.375v1.5c0 .207.168.375.375.375h1.5A.375.375 0 0 0 21 7.125v-1.5a.375.375 0 0 0-.375-.375h-1.5ZM21 9.375A.375.375 0 0 0 20.625 9h-1.5a.375.375 0 0 0-.375.375v1.5c0 .207.168.375.375.375h1.5a.375.375 0 0 0 .375-.375v-1.5Zm0 3.75a.375.375 0 0 0-.375-.375h-1.5a.375.375 0 0 0-.375.375v1.5c0 .207.168.375.375.375h1.5a.375.375 0 0 0 .375-.375v-1.5Zm0 3.75a.375.375 0 0 0-.375-.375h-1.5a.375.375 0 0 0-.375.375v1.5c0 .207.168.375.375.375h1.5a.375.375 0 0 0 .375-.375v-1.5ZM4.875 18.75a.375.375 0 0 0 .375-.375v-1.5a.375.375 0 0 0-.375-.375h-1.5a.375.375 0 0 0-.375.375v1.5c0 .207.168.375.375.375h1.5ZM3.375 15h1.5a.375.375 0 0 0 .375-.375v-1.5a.375.375 0 0 0-.375-.375h-1.5a.375.375 0 0 0-.375.375v1.5c0 .207.168.375.375.375Zm0-3.75h1.5a.375.375 0 0 0 .375-.375v-1.5A.375.375 0 0 0 4.875 9h-1.5A.375.375 0 0 0 3 9.375v1.5c0 .207.168.375.375.375Zm4.125 0a.75.75 0 0 0 0 1.5h9a.75.75 0 0 0 0-1.5h-9Z"
      clipRule="evenodd"
    />
  </svg>
);
